import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
	reason: Yup.string().required('Укажите причину'),
});

export default validationSchema;
